import { FC, ReactNode } from 'react'
import { StyleButton, StyleButtonWrapper } from './style'
import theme from '@utils/theme'
interface ButtonProps {
  type?: 'button' | 'submit' | 'reset'
  title: string
  width?: number
  height?: number
  bg?: keyof typeof theme.colors
  tc?: keyof typeof theme.colors
  radius?: number
  styleButton?: string
  leftComponent?: ReactNode
  rightComponent?: ReactNode
  loading?: boolean
  disabled?: boolean
  outline?: boolean
  onClick?: () => void
  border?: keyof typeof theme.colors
  styleButtonWrapper?: string
}
const Button: FC<ButtonProps> = ({
  type = 'button',
  title,
  loading,
  disabled = false,
  leftComponent,
  rightComponent,
  styleButtonWrapper,
  ...restProps
}) => {
  return (
    <StyleButtonWrapper styleButtonWrapper={styleButtonWrapper}>
      <StyleButton
        disabled={!!loading ? loading : disabled}
        type={type}
        {...restProps}
      >
        {leftComponent && leftComponent}
        {!!loading ? 'Loading...' : title}
        {rightComponent && rightComponent}
      </StyleButton>
    </StyleButtonWrapper>
  )
}

export default Button
